module.exports = __webpack_public_path__ + "static/media/badge-dollar.a7c5eb05.svg";